import React from 'react';
import { PDFExport } from '@progress/kendo-react-pdf';
import { Sine, TimelineMax } from "gsap/all";
import $ from "jquery"; //only used in celebration

import StepShell from '../StepComponents/StepShell';
import ApplicationReview from './StepReviewComponents/ApplicationReview';
import { getApp } from '../../index';

// Set API response status and response to state
export function responder(status, response) {

    this.setState({
        xhrStatus: status,
        xhrResponse: response
    });

}

class StepCompleted extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            xhrStatus: "loading",
            xhrResponse: "",
            version: 1
        }

        responder = responder.bind(this);
    }

    render() {

        document.querySelector('body').classList.remove('hidden-header');

        return (
            <div className="hug p-lg-y">
                {this.state.xhrStatus === "success" ? <SuccessfulCompletion /> : this.state.xhrStatus === "failure" ? <FailedCompletion response={this.state.xhrResponse} /> : <Loader />}
            </div>
        )
    }
}

class Celebration extends React.Component {
    render() {

        var vw = $(window).width(),
            vh = $(window).height(),
            num = vw / 10;

        num = Math.max(num, 50);

        function random(high) {
            return Math.random() * (high * 1);
        }

        for (var i = 0; i <= num; i++) {
            $('#confetti-container').append("<div class='confetti'></div>");
        }

        var $confetti = $('.confetti'),
            tl = new TimelineMax();

        tl.add('start')

        $confetti.each(function (index, element) {
            var dot = $(this),
                dotTL = new TimelineMax();

            //set each confetti piece
            dotTL.set(dot, {
                x: random(vw),
                y: random(-vh) - 10,
                scale: random(1) + 1,
                opacity: random(1),
                transformStyle: "preserve-3d"
            });

            tl.to(dot, 6, {
                y: vh + 100,
                ease: Sine.easeInOut,
                repeat: -1,
                opacity: random(2),
                delay: -6,
                scale: random(1) + 1
            }, random(6), 'start')

            tl.to(dot, 2, {
                x: '+=' + random(100),
                repeat: -1,
                yoyo: true,
                ease: Sine.easeInOut
            }, random(2), 'start')

            tl.to(dot, random(4), {
                repeat: -1,
                yoyo: true,
                rotationX: random(270),
                rotationY: random(270),
                ease: Sine.easeInOut
            }, random(2), 'start')

        });

        return (
            <div id="confetti-container">
                <div className="modal-content">
                    <div className="modalImg"></div>
                </div>
            </div>
        )
    }
}

class SuccessfulCompletion extends React.Component {

    exportPDF = () => {
        this.overview.save();
    }

    clickPrint() {
        window.print();
    }

    render() {
        var rFirstName = getApp('fname');
        var firstName = rFirstName.charAt(0).toUpperCase() + rFirstName.slice(1);
        return (
            <div>
                <Celebration />
                <StepShell
                    stepID="StepCompleted"
                    friendlyText={`Success! We got your application, ${firstName}. We will get back to you soon.`}
                    requestText="You can download or print your application for your records."
                    progress="100%"
                    backLink="/"
                    progressLabel="Completed"
                >
                    <div className="hug m-y-b">
                        <span id="loanApp_print" className="print" onClick={this.clickPrint.bind(this)}>print</span>
                        {/* <span id="loanApp_download" className="download" onClick={this.exportPDF}>download</span> */}
                    </div>
                    <PDFExport paperSize={'Letter'}
                        fileName="loan-application.pdf"
                        title=""
                        subject=""
                        keywords=""
                        ref={(o) => this.overview = o}>
                        <div style={{ padding: "1em" }}>
                            <ApplicationReview />
                        </div>
                    </PDFExport><br />
                </StepShell>
            </div>
        )
    }
}

class FailedCompletion extends React.Component {
    render() {
        var rFirstName = getApp('fname');
        var firstName = rFirstName.charAt(0).toUpperCase() + rFirstName.slice(1);
        return (
            <StepShell
                stepID="StepCompleted"
                friendlyText={`I apologize, ${firstName}. We are unable to submit your application at this time. Please contact us by phone at (520) 751-7008.`}
                requestText="Your application was not submitted for the following reason:"
                progress="100%"
                backLink="/"
                progressLabel="Completed"
            >
                <div className="failed-response-message">
                    {this.props.response}
                </div>
            </StepShell>
        )
    }
}

class Loader extends React.Component {
    render() {
        //var rFirstName = getApp('fname');
        //var firstName = rFirstName.charAt(0).toUpperCase() + rFirstName.slice(1);
        return (
            <StepShell
                stepID="StepCompleted"
                friendlyText={`We appreciate your patience.`}
                requestText="Your application is being submitted. Please standby."
                progress="100%"
                backLink="/"
                progressLabel="Completed"
            >
                <div className="loader"></div>
            </StepShell>
        )
    }
}

// class phoneLink extends React.Component {
//     render() {
//         return (
//             <a href="tel:5207517008" targe="_blank" >(520) 751-7008</a>
//         )
//     }
// }

export default StepCompleted;
